import { Component } from 'react';
import Header from '../../../Header';
import Footer from '../../../Footer';
import Lgpd from '../../../Lgpd';
import ErrorBoundary from '../../../ErrorHandler/ErrorBoundary';
import InfoComponent from '../../InfoComponent';

class Comite extends Component {
	render() {
		return (
			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<main>

					<InfoComponent image={"comite"} page={'comite'}></InfoComponent>						
					
				</main>
				{/* FOOTER */}
				<ErrorBoundary>	<Footer /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default Comite;